import { Layout } from 'antd'
import { Content, Header } from 'antd/es/layout/layout'
import { Link } from 'react-router-dom'
import { HeaderMenu } from '../../components/header-menu'

export function Adulting101Page() {
  return (
    <Layout>
      <Header>
        <h1>Adulting 101</h1>
      </Header>
      <HeaderMenu selected="adulting-101" />
      <Content>
        <h2>So you want to be an adult? You think your parents are being unfair to you?</h2>
        <h4> Heres the basics. When your parents can stop doing this stuff for you. Maybe you will actully appreciate them.</h4>
        <Content style={{ padding: '20px', textAlign: 'left' }}>
          <h3>
            <Link to="/adulting-101/quiz">Take the "Am I An Adult Yet?" Quiz</Link>
          </h3>
          <h3>Attributes</h3>
          <ul>
            <li>
              <Link to="/adulting-101/hygiene">Hygiene</Link>
            </li>
            <li>
              <Link to="/adulting-101/time-management">Time Management</Link>
            </li>
            <li>
              <Link to="/adulting-101/communication-skills">Communication Skills</Link>
            </li>
            <li>
              <Link to="/adulting-101/responsibility">Responsibility</Link>
            </li>
            <li>
              <Link to="/adulting-101/emotional-intelligence">Emotional Intelligence</Link>
            </li>
            <li>
              <Link to="/adulting-101/problem-solving">Problem Solving</Link>
            </li>
            <li>
              <Link to="/adulting-101/financial-literacy">Financial Literacy</Link>
            </li>
            <li>
              <Link to="/adulting-101/spiritual-awareness">Spiritual Awareness</Link>
            </li>
            <li>
              <Link to="/adulting-101/household-care">Household Care</Link>
            </li>
            <li>
              <Link to="/adulting-101/friends-and-family">Friends and Family</Link>
            </li>
          </ul>
        </Content>
      </Content>
    </Layout>
  )
}
